import { useQuery } from "@tanstack/react-query";
import { getPackages } from "../api/packages/get-packages";
import type { PackagesResponse } from "../api/packages/types";

export function usePackages() {
  return useQuery<PackagesResponse | null>({
    queryKey: ["packages"],
    queryFn: getPackages,
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchInterval: 60 * 1000,
  });
}

